<template>
  <div class="not-result">
    <MissingGames
      class="not-result__empty"
      src="/img/lobby/not-found.webp"
      :desk="$t('lobby.search.empty1')"
      :desk2="$t('lobby.search.empty2')"
      :text="$t('lobby.search.empty3', { value })"
    />

    <GamesSlider v-if="list && list.length" :list="list" />

    <div v-if="!isLoggedIn" class="not-result__registration-info">
      <RegistrationInfo />
    </div>

    <div class="not-result__support">
      <UiText
        class="not-result__support-title"
        color="typography-body01"
        font="body-text-small"
        :text="$t('lobby.search.support')"
      />

      <BaseSupportButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GamesSlider from '@/components/Lobby/SearchModal/components/GamesSlider'
import MissingGames from '@/components/Lobby/MissingGames'
import BaseSupportButton from '@/components/Base/SupportButton'

export default {
  name: 'ViewNotFound',
  components: {
    MissingGames,
    GamesSlider,
    BaseSupportButton,
    RegistrationInfo: () => import('@/components/Lobby/SearchModal/components/RegistrationInfo'),
  },
  props: {
    list: { type: Array },
    value: { type: String },
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('onMountResult')
    })
  },
}
</script>

<style lang="scss" scoped>
.not-result {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  row-gap: var(--spaces-xl);
  padding: 0 var(--padding-xl) var(--spaces-3xl) var(--padding-xl);

  @include media (tablet-album) {
    justify-content: space-between;
    row-gap: var(--spaces-m);
    padding: 0;
  }

  &__empty {
    margin-top: 17px;

    @include media (tablet-album) {
      margin-top: -13px;
    }

    & ::v-deep .empty-block__icon {
      width: 162px;
      height: 162px;
      margin-bottom: 0;
    }
  }

  &__registration-info {
    display: flex;
    align-self: center;

    @include media (tablet-album) {
      position: absolute;
      right: 24px;
      bottom: 24px;
      margin: 0;
    }
  }

  &__support {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__support-title {
    margin-bottom: var(--spaces-s);
  }
}
</style>
